var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProvisionalSuccessMobile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 120,
    viewBox: "0 0 130 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_71858_280549)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_71858_280549",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 0,
    width: 121,
    height: 120
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.5773 0.000122292L5.12305 62.6875L67.6552 120L125.109 57.3128L62.5773 0.000122292Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_71858_280549)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.6605 60.4375C98.4444 60.5676 98.177 60.6129 97.582 60.4817C97.5681 60.7433 97.6288 60.9764 97.7983 61.2608C98.2545 61.2971 98.5287 61.2795 98.9457 61.1239C98.7657 60.9212 98.7165 60.7578 98.6578 60.4405L98.6605 60.4375Z",
    fill: "url(#paint0_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.842 53.3295C104.155 53.299 104.438 53.3484 104.772 53.6173C105.171 52.6486 105.305 51.9862 105.438 50.9954C104.917 50.6785 104.561 50.6323 104.302 50.6211C104.396 51.6862 104.218 52.3506 103.842 53.3295Z",
    fill: "url(#paint1_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9492 69.474C76.9836 69.6184 77.0739 69.6959 77.2252 69.8184C77.477 69.4791 77.8462 69.1936 78.3021 68.9015C78.1881 68.7971 78.1365 68.7067 78.0929 68.543C77.5914 68.8203 77.3364 69.0222 76.9521 69.4767L76.9492 69.474Z",
    fill: "url(#paint2_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.392 66.2173C101.296 65.8764 101.316 65.6426 101.565 65.3006C101.105 65.228 100.787 65.2868 100.216 65.4351C100.028 65.7099 100.025 65.9008 100.128 66.2584C100.62 66.1387 100.982 66.0837 101.392 66.2173Z",
    fill: "url(#paint3_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6111 38.7969C84.2638 38.9411 84.0753 38.9942 83.7594 38.9575C83.7742 39.1056 83.7643 39.1986 83.7031 39.277C84.0426 39.3408 84.2823 39.3023 84.6671 39.1817C84.6863 39.0434 84.6642 38.9209 84.6111 38.7969Z",
    fill: "url(#paint4_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9591 50.3125C79.4379 50.6523 79.1049 50.8043 78.4941 50.9544C78.5633 51.2544 78.6722 51.4994 78.8882 51.6921C79.3093 51.6316 79.8008 51.4475 80.4326 51.1337C80.0702 50.8661 79.9269 50.6703 79.9593 50.3181L79.9591 50.3125Z",
    fill: "url(#paint5_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9831 35.5004C56.4286 35.3547 56.6728 35.0354 56.9275 34.4406C56.0412 33.9348 55.5777 33.5369 54.9885 32.7656C54.7795 33.1872 54.5028 33.4069 53.8828 33.7313C54.492 34.5102 55.1048 34.9858 55.9887 35.5001L55.9831 35.5004Z",
    fill: "url(#paint6_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.57 34.6762C87.3415 34.3269 87.18 34.1628 86.7484 34.0469C86.2709 34.5504 85.9511 34.8112 85.3926 35.1976C85.5953 35.3403 85.7054 35.4842 85.776 35.6242C86.4041 35.1619 86.8498 34.9573 87.57 34.6762Z",
    fill: "url(#paint7_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6872 99.2259C84.1261 99.2516 84.4488 99.058 84.8762 98.6269C84.2768 97.8784 84.0105 97.3709 83.7618 96.4922C83.4352 96.7898 83.1166 96.8851 82.4629 96.9528C82.7234 97.8423 83.0987 98.4714 83.6872 99.2259Z",
    fill: "url(#paint8_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2011 64.5781C15.9982 64.9461 15.9322 65.1707 16.0326 65.6069C16.7058 65.7937 17.0943 65.9507 17.7 66.2639C17.7312 66.0128 17.8055 65.8496 17.8953 65.7222C17.1875 65.3854 16.7929 65.0883 16.2011 64.5781Z",
    fill: "url(#paint9_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4824 71.8286C46.9781 72.9015 47.4032 73.5115 48.0774 74.237C48.6193 73.6634 48.8577 73.2097 48.9799 72.7301C48.4711 72.3874 48.256 71.959 47.979 71.2695C47.4771 71.7292 47.1057 71.8351 46.4851 71.8257L46.4824 71.8286Z",
    fill: "url(#paint10_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1816 89.2829C34.8522 89.989 35.4604 90.4872 36.2363 90.7144C36.7317 90.2972 36.9545 89.9367 37.0821 89.4513C36.1631 89.0984 35.6996 88.765 35.0724 88.0234C34.9071 88.6733 34.712 89.0269 34.1843 89.28L34.1816 89.2829Z",
    fill: "url(#paint11_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9425 65.3591C61.9354 65.1966 61.9685 65.0549 62.0362 64.8695C61.6253 64.9071 61.3533 64.9105 61.0452 64.8594C60.918 65.0333 60.9007 65.1519 60.9025 65.3202C61.1263 65.3694 61.5087 65.3864 61.9425 65.3591Z",
    fill: "url(#paint12_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6106 31.279C67.6362 31.9317 67.3929 32.5962 66.3418 33.7841C66.9247 34.1516 67.5292 34.3076 68.3865 34.2759C69.0448 33.2819 69.3562 32.6369 69.5252 31.4903C68.8359 31.6438 68.4053 31.5503 67.6103 31.2734L67.6106 31.279Z",
    fill: "url(#paint13_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7788 74.4866C98.0482 74.357 98.1946 74.3029 98.4479 74.3199C98.426 74.203 98.4311 74.127 98.4788 74.0632C98.205 74.0274 98.016 74.0694 97.7179 74.1834C97.7116 74.2959 97.7326 74.3904 97.7788 74.4866Z",
    fill: "url(#paint14_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.959 84.9825C53.1363 85.2526 53.3906 85.3565 53.8312 85.4215C54.0092 84.7403 54.1891 84.362 54.5982 83.8335C54.2785 83.7716 54.0841 83.6258 53.7599 83.2695C53.3515 83.8148 53.1484 84.3063 52.9619 84.9852L52.959 84.9825Z",
    fill: "url(#paint15_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8443 76.7662C70.3241 76.2486 70.5284 75.9142 70.5459 75.1557C69.5271 74.5715 68.9617 74.1556 68.0978 73.3906C67.9466 73.7845 67.7522 74.0258 67.5547 74.1944C68.5709 75.0397 69.0873 75.6851 69.8441 76.7606L69.8443 76.7662Z",
    fill: "url(#paint16_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2134 30.5435C45.6932 30.0259 45.8975 29.6915 45.915 28.9331C44.8961 28.3489 44.3308 27.9329 43.4668 27.168C43.3156 27.5618 43.1213 27.8032 42.9238 27.9717C43.94 28.817 44.4563 29.4624 45.2132 30.5379L45.2134 30.5435Z",
    fill: "url(#paint17_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9538 52.5959C84.1364 52.5782 83.6939 52.662 83.0254 53.2271C83.3077 54.5562 83.3794 55.3641 83.3868 56.6939C83.8452 56.5224 84.1979 56.5014 84.4972 56.5445C84.442 55.0204 84.6059 54.0787 84.9538 52.5959Z",
    fill: "url(#paint18_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8527 95.6386C75.0451 95.6106 75.2197 95.6254 75.4497 95.6856C75.3473 95.2046 75.3079 94.8779 75.3254 94.5068C75.101 94.3818 74.9576 94.3741 74.7593 94.3967C74.7318 94.6673 74.7657 95.1233 74.8554 95.6357L74.8527 95.6386Z",
    fill: "url(#paint19_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6808 62.0537C47.3896 62.5182 47.1154 63.0521 47.1541 63.6846C47.4771 64.0129 47.6756 64.254 47.907 64.6705C48.0361 64.2832 48.2796 64.1407 48.8437 64.0123C48.3641 63.5028 48.0708 62.8898 47.6835 62.0508L47.6808 62.0537Z",
    fill: "url(#paint20_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.855 101.247C71.628 100.932 71.5951 100.692 71.5987 100.324C71.0266 100.59 70.4798 100.923 70.293 101.144C70.4119 101.425 70.5751 101.629 70.8389 101.887C71.0522 101.63 71.3489 101.483 71.855 101.247Z",
    fill: "url(#paint21_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4301 66.8879C84.7256 66.9705 84.9521 66.8877 85.3189 66.7398C84.9647 65.9526 84.8229 65.0159 84.7607 63.9102C84.4594 64.0159 84.2514 64.0081 83.9082 63.9249C83.9059 65.0952 84.0046 65.7503 84.4301 66.8879Z",
    fill: "url(#paint22_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6947 32.7542C96.9042 32.731 97.0284 32.619 97.2249 32.428C96.7916 32.0147 96.4581 31.4456 96.1276 30.75C95.9627 30.8947 95.8246 30.9456 95.582 30.9814C95.8843 31.7371 96.1204 32.131 96.6891 32.7544L96.6947 32.7542Z",
    fill: "url(#paint23_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2301 52.5951C91.0946 52.3204 91.0518 52.0445 91.1862 51.6514C90.1683 51.6059 89.5161 51.7073 88.5653 51.9114C88.4504 52.4945 88.5242 52.8365 88.6019 53.0744C89.5452 52.632 90.2135 52.5777 91.2301 52.5951Z",
    fill: "url(#paint24_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0449 76.3838C58.2875 76.5417 58.4821 76.564 58.7807 76.4612C58.8861 76.176 58.9214 75.9556 58.8556 75.734C58.5458 75.6436 58.3653 75.4943 58.0837 75.2148C58.134 75.6588 58.1544 75.9357 58.0449 76.3838Z",
    fill: "url(#paint25_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0622 85.0609C62.7068 84.8912 62.4348 84.8946 62.0473 85.0827C61.9555 85.488 61.9436 85.7944 62.0685 86.0864C62.5094 86.157 62.7778 86.3277 63.2133 86.6623C63.0666 86.0654 62.9943 85.6925 63.0622 85.0609Z",
    fill: "url(#paint26_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7323 93.3477C82.6305 93.5233 82.5993 93.6453 82.6064 93.8723C82.8575 93.8389 83.0075 93.8689 83.168 93.9461C83.2735 93.7899 83.3214 93.6672 83.3689 93.4687C83.1417 93.4702 82.9773 93.4324 82.7323 93.3477Z",
    fill: "url(#paint27_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9742 67.9197C65.8073 67.5678 65.6694 67.3661 65.4458 67.1289C65.2717 67.3189 65.1911 67.4655 65.1504 67.6273C65.318 67.7378 65.3916 67.8805 65.4827 68.1039C65.6473 67.9536 65.7691 67.9146 65.9742 67.9197Z",
    fill: "url(#paint28_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7857 53.9439C25.4147 53.1575 25.1034 52.7108 24.606 52.1797C24.2091 52.601 24.0357 52.9369 23.9473 53.2916C24.3231 53.5446 24.4798 53.8549 24.6898 54.3593C25.0594 54.0204 25.331 53.9413 25.7857 53.9439Z",
    fill: "url(#paint29_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6515 76.9443C84.6204 77.2599 84.5125 77.4246 84.3145 77.6465C84.8092 77.7933 85.3209 77.8805 85.5579 77.8449C85.6346 77.6086 85.6477 77.3948 85.6207 77.0957C85.3559 77.1381 85.0892 77.0711 84.6542 76.9414L84.6515 76.9443Z",
    fill: "url(#paint30_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.071 40.7296C41.4644 41.3214 41.8425 41.754 42.373 42.0143C42.7806 41.7748 42.9867 41.5442 43.135 41.2122C42.5185 40.8462 42.225 40.5503 41.8616 39.9375C41.6621 40.384 41.4785 40.6137 41.0684 40.7325L41.071 40.7296Z",
    fill: "url(#paint31_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5006 64.4893C77.7786 64.7494 77.9057 64.8982 78.0034 65.2083C78.1347 65.1296 78.226 65.1003 78.3198 65.1271C78.2377 64.7883 78.0995 64.5811 77.8311 64.2812C77.6955 64.3236 77.592 64.3954 77.498 64.4921L77.5006 64.4893Z",
    fill: "url(#paint32_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2246 85.8643C98.297 86.0435 98.399 86.1317 98.6034 86.1845C98.7695 86.0678 98.8742 85.9595 98.9209 85.8087C98.7845 85.6406 98.7387 85.4911 98.6907 85.2266C98.5507 85.4909 98.4567 85.6521 98.2273 85.8613L98.2246 85.8643Z",
    fill: "url(#paint33_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4373 42.6347C64.5264 42.426 64.657 42.2659 64.9436 42.1468C64.4745 41.5555 64.0987 41.2379 63.5187 40.8086C63.1354 41.0273 62.9817 41.2361 62.8848 41.3946C63.5916 41.709 63.9489 42.0526 64.4344 42.632L64.4373 42.6347Z",
    fill: "url(#paint34_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1915 56.7344C35.086 56.9551 34.9903 57.2062 35.0417 57.4846C35.2018 57.6151 35.3041 57.7089 35.4266 57.8803C35.4609 57.7021 35.5615 57.6275 35.8075 57.541C35.5659 57.3411 35.4087 57.0842 35.1915 56.7344Z",
    fill: "url(#paint35_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4191 42.8828C23.2752 43.3802 22.924 43.822 21.832 44.4561C22.1815 44.8786 22.5919 45.1526 23.2512 45.3428C24.0004 44.7601 24.3952 44.3528 24.8111 43.5293C24.2529 43.4695 23.9506 43.2946 23.422 42.8855L23.4191 42.8828Z",
    fill: "url(#paint36_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6197 81.2144C41.4082 80.9991 41.3132 80.8797 41.2492 80.6328C41.1449 80.6878 41.0702 80.7107 40.9961 80.6859C41.05 80.9558 41.1498 81.1226 41.3542 81.369C41.4623 81.3391 41.5471 81.2877 41.6197 81.2144Z",
    fill: "url(#paint37_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2732 74.5638C39.4255 74.4505 39.4698 74.3083 39.5324 74.0698C39.008 73.9496 38.4904 73.6633 37.9209 73.2812C37.8618 73.4691 37.7792 73.5709 37.6055 73.7076C38.1833 74.1511 38.5455 74.3486 39.2706 74.5667L39.2732 74.5638Z",
    fill: "url(#paint38_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3838 90.6498C43.6252 90.6505 43.8824 90.6281 44.1084 90.4695C44.1561 90.2766 44.198 90.1429 44.2995 89.9616C44.1273 90.0028 44.0182 89.9458 43.8392 89.7656C43.7623 90.0608 43.602 90.3119 43.3809 90.6471L43.3838 90.6498Z",
    fill: "url(#paint39_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2941 53.1797C43.7875 53.4683 43.5444 53.6866 43.3457 54.2789C44.008 54.9881 44.3539 55.4557 44.8496 56.2704C45.0678 55.9971 45.2775 55.8505 45.476 55.7688C44.8778 54.8548 44.6283 54.2174 44.2941 53.1797Z",
    fill: "url(#paint40_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1375 80.8195C46.1731 81.4438 46.2676 81.9392 46.556 82.3756C46.9713 82.3743 47.2314 82.2901 47.4927 82.1047C47.188 81.5511 47.094 81.196 47.092 80.5703C46.7437 80.8212 46.5009 80.916 46.1348 80.8225L46.1375 80.8195Z",
    fill: "url(#paint41_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8258 63.5727C71.9617 62.8905 71.9317 62.4597 71.6498 61.7227C70.8666 62.102 70.3395 62.1782 69.7328 62.1008C69.5583 62.7314 69.5444 63.1866 69.6114 63.8881C70.3577 63.6255 70.9305 63.5696 71.8232 63.5757L71.8258 63.5727Z",
    fill: "url(#paint42_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1787 81.8204C66.2734 81.3532 66.2799 81.0527 66.2346 80.6562C65.9199 80.712 65.7331 80.8044 65.5787 80.9318C65.6618 81.1639 65.6309 81.3561 65.5566 81.6483C65.8304 81.6196 65.9758 81.6721 66.176 81.8233L66.1787 81.8204Z",
    fill: "url(#paint43_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9214 102.048C59.0994 101.948 59.1881 101.857 59.2969 101.65C59.0597 101.551 58.9401 101.447 58.841 101.297C58.6678 101.38 58.5621 101.466 58.4199 101.615C58.6213 101.73 58.747 101.845 58.9185 102.045L58.9214 102.048Z",
    fill: "url(#paint44_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4014 57.1719C54.9099 57.3799 55.1348 57.6451 55.4039 58.0908C55.8902 57.3372 56.2955 56.5254 56.3561 56.113C56.0029 55.8646 55.6495 55.7397 55.1397 55.6328C55.0759 56.1014 54.8353 56.5048 54.3984 57.1692L54.4014 57.1719Z",
    fill: "url(#paint45_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9531 66.8444C39.3102 67.3115 39.6716 67.4922 40.3173 67.4977C40.7148 67.023 40.9359 66.6233 40.9629 66.1479C40.4268 65.7587 40.1817 65.3513 39.8326 64.6172C39.6245 65.5074 39.4686 66.053 38.9531 66.8444Z",
    fill: "url(#paint46_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.937 70.9903C101.72 71.3561 101.751 71.6915 101.823 72.2412C103.007 72.0409 104.326 72.1799 105.835 72.4874C105.799 72.0456 105.885 71.764 106.119 71.3329C104.54 70.9134 103.621 70.8187 101.934 70.9932L101.937 70.9903Z",
    fill: "url(#paint47_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7304 81.0684C29.9795 80.4501 29.6353 80.0862 29.3352 79.3164C29.0164 79.5351 28.7872 79.6209 28.541 79.5727C28.8082 80.4253 29.1836 80.9253 29.9196 81.6537C30.2592 81.5239 30.5088 81.3278 30.7302 81.0628L30.7304 81.0684Z",
    fill: "url(#paint48_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6582 94.2934C60.7725 94.5971 60.8102 94.8845 60.7966 95.2807C61.5424 94.9424 62.0619 94.757 62.6773 94.6488C62.8025 94.2364 62.7586 94.0026 62.6495 93.6875C62.1972 93.7408 61.4631 93.9608 60.6582 94.2934Z",
    fill: "url(#paint49_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1455 38.2965C30.3917 38.2802 30.6129 38.3323 30.8637 38.5515C31.21 37.804 31.3335 37.2879 31.471 36.5158C31.0723 36.2525 30.7922 36.2002 30.5922 36.1836C30.6315 37.021 30.4689 37.5388 30.1426 38.2939L30.1455 38.2965Z",
    fill: "url(#paint50_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0396 84.1707C93.7734 84.3731 93.4889 84.4781 93.0371 84.4136C93.2028 85.512 93.4457 86.1918 93.8642 87.167C94.5096 87.1669 94.8623 87.0168 95.1007 86.8858C94.4321 85.9664 94.2304 85.2652 94.0366 84.168L94.0396 84.1707Z",
    fill: "url(#paint51_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9121 83.0828C76.4474 83.1325 76.9613 83.3991 77.818 84.3833C78.1779 83.9495 78.3732 83.4723 78.4382 82.7735C77.7002 82.1294 77.2092 81.8084 76.2943 81.5508C76.3448 82.1295 76.225 82.4715 75.915 83.0855L75.9121 83.0828Z",
    fill: "url(#paint52_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3259 69.1059C73.0904 68.7878 72.9269 68.6434 72.5134 68.5547C72.0891 69.0587 71.8005 69.3266 71.293 69.722C71.4949 69.8479 71.6072 69.9777 71.68 70.1036C72.2487 69.6298 72.6574 69.4128 73.3259 69.1059Z",
    fill: "url(#paint53_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1444 55.5795C68.8652 55.485 68.6823 55.4734 68.3574 55.5521C68.4766 55.9033 68.478 56.1305 68.413 56.3775C68.6702 56.4841 68.8595 56.5124 69.1603 56.5245C69.0899 56.1965 69.0989 55.9519 69.1471 55.5766L69.1444 55.5795Z",
    fill: "url(#paint54_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8041 59.7881C92.7696 60.219 92.8025 60.4589 93.0823 60.8283C93.7959 60.7187 94.2246 60.7028 94.9333 60.7393C94.8551 60.4901 94.8554 60.3021 94.8878 60.1435C94.076 60.1256 93.5828 60.0124 92.8068 59.7852L92.8041 59.7881Z",
    fill: "url(#paint55_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5909 44.6542C86.4681 44.2189 86.2993 43.7576 85.8893 43.4303C85.5111 43.444 85.2524 43.4328 84.8752 43.3398C85.0393 43.6301 84.9904 43.8596 84.7559 44.2739C85.3307 44.2629 85.8653 44.4248 86.5879 44.6515L86.5909 44.6542Z",
    fill: "url(#paint56_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.137 45.3621C55.4774 45.5536 55.1401 45.7338 54.752 46.3569C55.3144 47.3511 55.5775 47.9794 55.9186 49.045C56.2415 48.7924 56.5204 48.6876 56.771 48.643C56.3422 47.4326 56.2318 46.6376 56.1341 45.3594L56.137 45.3621Z",
    fill: "url(#paint57_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1121 43.1296C48.5276 42.8757 48.9543 42.5569 49.1729 42.0366C49.0438 41.6494 48.9814 41.3771 48.9631 40.957C48.7106 41.2149 48.4588 41.2315 47.957 41.1158C48.14 41.7084 48.1327 42.3149 48.1121 43.1296Z",
    fill: "url(#paint58_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4844 99.929C63.7419 100.751 63.8225 101.25 63.7931 102.121C64.2206 102.142 64.5857 102.084 64.9215 101.87C64.9972 101.289 64.9319 100.562 64.7526 99.6016C64.2587 99.9879 63.944 100.108 63.4873 99.9317L63.4844 99.929Z",
    fill: "url(#paint59_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5962 78.8435C57.3819 78.4319 57.2063 78.201 56.9279 77.9297C56.7247 78.1631 56.6429 78.3463 56.6035 78.536C56.811 78.6616 56.8994 78.8234 57.0205 79.0903C57.2088 78.9025 57.3524 78.8513 57.5962 78.8435Z",
    fill: "url(#paint60_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5856 89.0572C89.5339 89.0076 88.8807 89.0865 88.0293 89.3172C88.2546 89.9809 88.5179 90.3567 88.8451 90.6511C89.3248 90.3917 89.7489 90.3985 90.4084 90.4652C90.254 89.8826 90.3234 89.5428 90.5856 89.0572Z",
    fill: "url(#paint61_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7548 93.6439C65.6564 93.6398 65.5739 93.6125 65.4798 93.5156C65.3181 93.7977 65.2483 93.9971 65.166 94.2982C65.3143 94.418 65.4222 94.447 65.5014 94.4604C65.515 94.1286 65.599 93.9313 65.7548 93.6439Z",
    fill: "url(#paint62_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7823 61.805C89.3439 62.5004 89.1486 62.9775 88.9785 63.6444C89.516 63.7444 89.8708 63.7093 90.2001 63.6024C90.2096 63.1754 90.3767 62.8875 90.6755 62.4676C90.2212 62.3471 90.0171 62.1708 89.7879 61.8047L89.7823 61.805Z",
    fill: "url(#paint63_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.511 68.6988C21.2597 68.7911 21.0135 68.8074 20.6842 68.6562C20.5571 69.5401 20.5878 70.1169 20.6809 70.966C21.1785 71.1154 21.483 71.0825 21.697 71.0367C21.3957 70.1743 21.4066 69.5873 21.5083 68.7017L21.511 68.6988Z",
    fill: "url(#paint64_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5879 69.6254C54.6427 69.8531 54.7462 69.9749 54.981 70.0825C55.2036 69.9746 55.3475 69.8645 55.4328 69.6952C55.2993 69.4653 55.2771 69.2783 55.2685 68.9531C55.0484 69.2461 54.9045 69.4208 54.5879 69.6254Z",
    fill: "url(#paint65_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9492 94.1572C43.3114 94.3547 43.7235 94.5388 44.198 94.4789C44.431 94.2246 44.6008 94.0628 44.904 93.8729C44.6088 93.7959 44.4916 93.6186 44.3669 93.2031C44.0048 93.5865 43.5581 93.8333 42.9495 94.1628L42.9492 94.1572Z",
    fill: "url(#paint66_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.591 97.0236C78.4139 96.8882 78.2424 96.8816 77.9563 96.8829C77.9833 97.5047 77.8243 98.1711 77.5684 98.9315C77.7962 98.9412 77.9364 99.0052 78.142 99.1506C78.4586 98.3651 78.5674 97.9002 78.591 97.0236Z",
    fill: "url(#paint67_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4922 56.0943C67.7231 56.3059 67.8979 56.3909 68.2458 56.4515C68.2793 56.0628 68.3736 55.8426 68.5438 55.6276C68.3409 55.4147 68.1706 55.3071 67.884 55.168C67.8122 55.5163 67.7016 55.7484 67.4948 56.0914L67.4922 56.0943Z",
    fill: "url(#paint68_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4491 67.0904L89.0434 68.2783C89.0434 68.2783 86.8329 68.0378 85.8186 68.9744C85.6513 69.1276 85.519 69.3129 85.4277 69.5358L85.8334 68.3479C86.4575 66.7633 89.4491 67.0904 89.4491 67.0904Z",
    fill: "url(#paint69_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1287 89.3679C84.0581 89.5506 83.9534 89.7235 83.8204 89.892C83.718 87.862 80.6129 84.7364 81.5605 81.6251C81.5727 81.5825 81.5849 81.5399 81.6027 81.497C81.6126 81.4685 81.6226 81.44 81.6326 81.4115C81.6857 81.2773 81.7531 81.1509 81.8323 81.0352C81.3632 84.2463 84.7245 87.3916 84.1689 89.2595C84.1565 89.2965 84.1467 89.3306 84.1343 89.3676L84.1287 89.3679Z",
    fill: "url(#paint70_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3012 76.2543C89.2214 76.4823 89.1152 76.6862 88.9825 76.8603C88.9377 74.5443 84.968 71.0888 85.4138 69.5989C85.4138 69.5989 85.4262 69.5619 85.4338 69.5419C85.5195 69.3193 85.6573 69.1337 85.8247 68.9805C86.2503 70.8281 89.9981 74.2147 89.3042 76.257L89.3012 76.2543Z",
    fill: "url(#paint71_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1288 89.3672L83.7258 90.5521C82.9909 92.4923 78.2081 93.5622 77.4668 95.6149L77.8725 94.4271C78.5463 92.5653 82.5274 91.5135 83.8205 89.8913C83.9535 89.7228 84.0609 89.5469 84.1288 89.3672Z",
    fill: "url(#paint72_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3032 76.2539L88.8975 77.4417C88.0119 80.0452 83.1843 79.0572 81.8363 81.0326C81.7572 81.1482 81.6924 81.2717 81.6367 81.4089L82.0423 80.221C82.9341 77.9512 87.5069 78.824 88.9817 76.8628C89.1171 76.6857 89.2262 76.4845 89.3005 76.2568L89.3032 76.2539Z",
    fill: "url(#paint73_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1144 94.5089C71.8824 96.1409 68.2018 97.0055 67.5137 98.6659L67.5557 97.6987C68.1932 96.164 71.3803 95.3096 72.0429 93.9001C72.0919 93.7998 72.1267 93.6972 72.1445 93.5898L72.1204 94.2616L72.1114 94.5061L72.1144 94.5089Z",
    fill: "url(#paint74_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.83 91.4162C70.1249 91.722 69.2245 91.8594 68.3542 91.7233C67.9275 91.6549 67.7402 91.5424 67.7292 91.4194C67.6898 91.0282 69.446 90.5673 70.83 91.4162Z",
    fill: "url(#paint75_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.635 88.2799C69.9874 88.4877 69.2725 88.5694 68.6612 88.4501C68.3782 88.3951 68.2571 88.3218 68.2598 88.2543C68.27 88.0378 69.5104 87.8463 70.635 88.2799Z",
    fill: "url(#paint76_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1389 89.9543L72.1384 90.0076C72.1333 90.0836 72.117 90.1601 72.0978 90.2339C72.0759 90.3106 72.0454 90.3849 72.0065 90.4568C71.95 90.3189 71.8625 90.1796 71.7444 90.0444C71.4277 89.6682 71.0183 89.4166 70.5957 89.2498C70.9389 89.1394 71.2608 88.9935 71.5397 88.8242C71.6245 88.9019 71.7095 88.9852 71.7864 89.0773C71.9491 89.2694 72.05 89.4587 72.1031 89.6472C72.1301 89.7526 72.146 89.8586 72.1419 89.957L72.1389 89.9543Z",
    fill: "url(#paint77_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5385 86.6255C72.5346 86.794 72.4745 86.9594 72.3749 87.1209C72.2504 86.9046 72.0251 86.6927 71.6797 86.4945L71.7218 85.5273C72.3175 85.869 72.5531 86.2516 72.5385 86.6255Z",
    fill: "url(#paint78_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1485 93.5903C72.1278 93.695 72.0959 93.8003 72.0469 93.9007C72.0309 93.8536 72.0121 93.8095 71.9933 93.7654C71.6927 93.1134 71.2638 92.672 70.791 92.3839C71.0582 92.2684 71.2962 92.1261 71.4942 91.9688C71.7005 92.1954 71.8836 92.4709 72.0354 92.7982C72.1068 92.9551 72.1496 93.102 72.1643 93.2445C72.1779 93.3646 72.1745 93.4797 72.1541 93.59L72.1485 93.5903Z",
    fill: "url(#paint79_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5349 86.6289L72.4928 87.5961C72.4731 88.046 72.0908 88.4808 71.536 88.822C71.2571 88.9913 70.9352 89.1372 70.592 89.2476C69.9444 89.4554 69.2296 89.537 68.6182 89.4177C68.3352 89.3627 68.2142 89.2894 68.2168 89.222L68.2589 88.2548C68.2562 88.3222 68.3773 88.3955 68.6603 88.4506C69.2716 88.5699 69.9865 88.4882 70.6341 88.2804C71.4005 88.031 72.0751 87.6059 72.3713 87.1244C72.4709 86.9629 72.5283 86.8004 72.5349 86.6289Z",
    fill: "url(#paint80_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1383 90.0065L72.0967 90.9849C72.0648 91.3483 71.841 91.6864 71.4913 91.9682C71.2933 92.1255 71.0554 92.2678 70.7882 92.3833C70.0831 92.689 69.1827 92.8264 68.3125 92.6903C67.8858 92.6219 67.6984 92.5094 67.6875 92.3864L67.7295 91.4193C67.7405 91.5423 67.9278 91.6548 68.3545 91.7232C69.2274 91.8563 70.1252 91.7218 70.8303 91.4161C71.3729 91.182 71.8015 90.8434 72.0034 90.453C72.0424 90.3811 72.0728 90.3068 72.0947 90.2301C72.1195 90.1561 72.1303 90.0798 72.1354 90.0039L72.1383 90.0065Z",
    fill: "url(#paint81_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8378 56.1288C41.3467 57.6978 38.4172 60.0844 38.5264 61.8841L38.1398 60.9973C38.0367 59.3377 40.5269 57.1723 40.5095 55.6128C40.5102 55.5005 40.4943 55.3945 40.4673 55.2891L40.7411 55.9058L40.8378 56.1288Z",
    fill: "url(#paint82_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3273 53.9126C37.8308 54.4954 37.0816 55.0135 36.2343 55.2749C35.8218 55.4023 35.6047 55.3809 35.5385 55.2772C35.3302 54.9411 36.707 53.7558 38.3273 53.9126Z",
    fill: "url(#paint83_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7782 51.1719C36.288 51.6423 35.6818 52.0279 35.08 52.1916C34.7999 52.2683 34.6618 52.2547 34.6338 52.1914C34.5492 51.9902 35.5789 51.2775 36.7782 51.1719Z",
    fill: "url(#paint84_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8639 52.0164L38.8855 52.0631C38.9167 52.1347 38.934 52.2098 38.9457 52.285C38.9603 52.3629 38.9638 52.4414 38.9618 52.5256C38.8537 52.4265 38.7124 52.3401 38.5465 52.2687C38.0974 52.0722 37.621 52.0228 37.168 52.0594C37.4266 51.8124 37.6531 51.5359 37.8292 51.2617C37.94 51.2933 38.0511 51.3306 38.1626 51.379C38.3916 51.4813 38.5682 51.6055 38.698 51.7514C38.7718 51.8352 38.8261 51.9226 38.8695 52.0161L38.8639 52.0164Z",
    fill: "url(#paint85_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7613 48.8517C37.8327 49.0085 37.8514 49.1817 37.8344 49.3704C37.6291 49.2307 37.3305 49.1398 36.9335 49.1094L36.5469 48.2227C37.2337 48.2713 37.6117 48.5102 37.764 48.8487L37.7613 48.8517Z",
    fill: "url(#paint86_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4677 55.2857C40.4948 55.3911 40.5106 55.4971 40.5099 55.6094C40.4748 55.5772 40.4397 55.5451 40.4017 55.5102C39.8488 55.0573 39.2672 54.8469 38.7148 54.7924C38.9016 54.5709 39.0572 54.3425 39.1651 54.1133C39.4508 54.2299 39.7358 54.3943 40.0151 54.6235C40.1462 54.7328 40.2521 54.8461 40.3276 54.9691C40.391 55.0701 40.4378 55.1775 40.4677 55.2857Z",
    fill: "url(#paint87_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7604 48.8555L38.147 49.7423C38.3277 50.1554 38.1753 50.7148 37.8232 51.2634C37.6471 51.5376 37.4206 51.8141 37.162 52.0611C36.6717 52.5314 36.0655 52.917 35.4637 53.0807C35.1836 53.1575 35.0455 53.1438 35.0175 53.0805L34.6309 52.1937C34.659 52.2571 34.7971 52.2707 35.0771 52.194C35.6819 52.0329 36.2881 51.6473 36.7754 51.1743C37.3572 50.6158 37.7739 49.9382 37.8306 49.3716C37.8505 49.1856 37.8288 49.0097 37.7604 48.8555Z",
    fill: "url(#paint88_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8848 52.0681L39.2775 52.9658C39.4103 53.308 39.3577 53.7116 39.1648 54.1156C39.0569 54.3448 38.9042 54.576 38.7145 54.7947C38.218 55.3776 37.4688 55.8957 36.6215 56.1571C36.2089 56.2845 35.9919 56.2631 35.9257 56.1593L35.5391 55.2726C35.6053 55.3763 35.8223 55.3977 36.2349 55.2703C37.0766 55.0092 37.8287 54.4937 38.3279 53.9079C38.7125 53.459 38.9465 52.969 38.9608 52.525C38.9657 52.4434 38.9594 52.3623 38.9447 52.2843C38.9331 52.2091 38.9101 52.1343 38.8846 52.0625L38.8848 52.0681Z",
    fill: "url(#paint89_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5488 49.8111C97.6984 51.226 93.9748 50.5884 92.6914 51.8537L93.1051 50.9798C94.289 49.8114 97.5583 50.2639 98.7197 49.2255C98.8035 49.1517 98.8729 49.0701 98.9335 48.9805L98.6486 49.5906L98.5461 49.814L98.5488 49.8111Z",
    fill: "url(#paint90_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5619 46.4638C97.7961 46.4719 96.9108 46.2466 96.1611 45.7854C95.7948 45.5572 95.6664 45.3804 95.7034 45.2637C95.8188 44.8855 97.6178 45.1467 98.5648 46.4664L98.5619 46.4638Z",
    fill: "url(#paint91_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6032 43.4992C98.9271 43.4388 98.2363 43.236 97.7217 42.888C97.4818 42.7272 97.4011 42.6157 97.4291 42.5499C97.5244 42.3522 98.7417 42.6611 99.6059 43.4962L99.6032 43.4992Z",
    fill: "url(#paint92_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.338 45.6213L100.315 45.67C100.279 45.7389 100.237 45.8025 100.189 45.8607C100.138 45.9219 100.082 45.9776 100.019 46.0281C100.021 45.8792 99.9919 45.7178 99.9395 45.5461C99.7929 45.0782 99.5176 44.6861 99.1895 44.3693C99.5473 44.4014 99.9005 44.3916 100.224 44.3438C100.273 44.4483 100.317 44.5587 100.353 44.6721C100.428 44.913 100.449 45.1254 100.423 45.3173C100.409 45.4274 100.382 45.5268 100.338 45.6213Z",
    fill: "url(#paint93_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.003 42.7099L102 42.7129C101.929 42.8675 101.811 42.9961 101.658 43.1038C101.628 42.8554 101.503 42.5746 101.262 42.2567L101.676 41.3828C102.093 41.9315 102.16 42.3748 102.003 42.7099Z",
    fill: "url(#paint94_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9328 48.9827C98.8721 49.0723 98.8 49.1568 98.7189 49.2277C98.7197 49.18 98.7204 49.1322 98.7182 49.0818C98.6955 48.3672 98.4711 47.7905 98.1484 47.3387C98.4402 47.3372 98.7134 47.2973 98.9575 47.2305C99.0571 47.5208 99.119 47.8465 99.1319 48.2079C99.1366 48.3789 99.1181 48.534 99.0762 48.6677C99.0419 48.7815 98.9932 48.8874 98.9298 48.98L98.9328 48.9827Z",
    fill: "url(#paint95_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.997 42.7156L101.584 43.5895C101.394 43.9963 100.869 44.2521 100.225 44.3447C99.9009 44.3924 99.5477 44.4022 99.19 44.3701C98.5138 44.3097 97.8231 44.1069 97.3084 43.7589C97.0685 43.5982 96.985 43.4839 97.0159 43.4209L97.4296 42.5469C97.3987 42.61 97.4823 42.7242 97.7222 42.885C98.2424 43.2327 98.9276 43.4358 99.6037 43.4962C100.407 43.565 101.193 43.4354 101.655 43.1065C101.808 42.9989 101.928 42.8674 101.997 42.7156Z",
    fill: "url(#paint96_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.316 45.6708L99.8938 46.5591C99.72 46.8838 99.3846 47.1089 98.955 47.2314C98.7083 47.3011 98.4377 47.3381 98.1459 47.3396C97.3801 47.3477 96.4948 47.1225 95.7451 46.6612C95.3788 46.433 95.2504 46.2562 95.2874 46.1396L95.7012 45.2656C95.6641 45.3823 95.7925 45.5591 96.1588 45.7873C96.9115 46.2512 97.7912 46.4767 98.5596 46.4657C99.1515 46.4595 99.6756 46.3161 100.017 46.0374C100.08 45.987 100.136 45.9312 100.187 45.8701C100.238 45.8145 100.28 45.7453 100.313 45.6793L100.316 45.6708Z",
    fill: "url(#paint97_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8196 97.25L58.6826 98.638C59.0236 99.1872 55.434 100.915 56.1545 102.382L55.4062 101.18C54.6801 100.23 55.985 99.1343 56.9511 98.3149C57.5086 97.8416 57.9494 97.4604 57.8225 97.2527L57.8196 97.25Z",
    fill: "url(#paint98_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8205 97.2471C57.9503 97.4575 57.5066 97.8361 56.9491 98.3093C55.5991 98.2391 53.8991 98.1868 53.482 97.568C53.4669 97.5434 53.4548 97.5215 53.4426 97.4995C53.3257 97.2633 53.3748 96.9749 53.5127 96.6602C54.9679 97.0206 57.5457 96.8017 57.8205 97.2471Z",
    fill: "url(#paint99_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0559 91.875L54.9189 93.263C55.4952 94.1892 53.9848 95.5908 53.5124 96.6637C53.3745 96.9784 53.3224 97.264 53.4423 97.503L52.5822 96.1177C52.1588 95.2886 53.8217 93.844 54.1363 92.6909C54.2162 92.3984 54.2069 92.121 54.0588 91.8777L54.0559 91.875Z",
    fill: "url(#paint100_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0556 91.8754C54.2064 92.1157 54.2157 92.3932 54.1331 92.6886C53.0069 92.2802 51.1583 92.4253 49.7996 90.8036C49.6515 90.6248 49.5202 90.4453 49.4055 90.2595C49.2606 90.0245 49.1436 89.7882 49.0547 89.5508C50.8114 91.4835 53.3075 90.6788 54.0527 91.8727L54.0556 91.8754Z",
    fill: "url(#paint101_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0209 83.0938L49.8839 84.4818C49.8839 84.4818 48.0986 87.0458 49.0637 89.5546C49.1527 89.7921 49.2696 90.0283 49.4145 90.2634L48.5515 88.8754C46.8846 86.1698 49.0238 83.0965 49.0238 83.0965L49.0209 83.0938Z",
    fill: "url(#paint102_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6013 46.1808L87.6489 48.153C87.7733 47.8529 87.8468 47.5438 87.8695 47.2258C88.0534 45.0064 86.1367 42.3623 86.1906 40.1206L87.143 38.1484C87.0806 40.7104 89.5977 43.8027 88.6013 46.1808Z",
    fill: "url(#paint103_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5174 48.4222C87.4344 48.5774 87.3343 48.7277 87.2115 48.8733C86.1836 50.1416 83.845 51.0853 82.452 51.8953C80.9685 52.7568 79.6546 53.7738 78.603 55.0796C78.3926 55.3385 78.1995 55.6079 78.0234 55.8822C78.1403 55.5375 78.2772 55.2004 78.4367 54.8679L78.4474 54.8563C78.7406 54.243 79.1107 53.6572 79.5581 53.1045C80.6097 51.7987 81.9236 50.7818 83.407 49.9202C84.6825 49.1799 86.7388 48.3271 87.8693 47.2227C87.844 47.5437 87.7731 47.8498 87.6487 48.1499C87.6104 48.2386 87.5695 48.3302 87.5201 48.4193L87.5174 48.4222Z",
    fill: "url(#paint104_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8941 73.3108C76.5081 74.0488 75.9647 74.6533 75.2188 75.0506L76.1712 73.0785C76.6539 72.8217 77.0487 72.479 77.3731 72.0664C77.2835 72.393 77.1734 72.7009 77.0405 72.9985C76.9918 73.1045 76.9457 73.2075 76.8912 73.3081L76.8941 73.3108Z",
    fill: "url(#paint105_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9273 71.1739L77.9219 71.1798L77.0414 72.9973C77.1717 72.7026 77.2815 72.3891 77.374 72.0652C78.1744 69.1792 77.4444 65.2402 76.9167 63.1753C76.3583 60.9856 76.5459 58.7857 77.4854 56.8394L78.4378 54.8672C78.2783 55.1997 78.1414 55.5368 78.0245 55.8814C77.4579 57.5618 77.4054 59.3853 77.8691 61.2032C78.4647 63.5401 79.3222 68.2789 77.9244 71.1713L77.9273 71.1739Z",
    fill: "url(#paint106_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4239 45.8811L60.4856 47.2984C60.4639 47.1225 60.4232 46.9615 60.3631 46.8042C59.8934 45.5562 58.2915 44.8571 56.5561 44.3799L56.4941 42.957C58.4453 43.4922 60.2292 44.3097 60.4236 45.8755L60.4239 45.8811Z",
    fill: "url(#paint107_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6899 57.8377C58.5966 57.693 58.5396 57.5439 58.5153 57.3709C58.4826 57.1366 58.5101 56.8661 58.5958 56.5144C58.8644 55.529 59.7319 54.8288 60.1152 54.0938C60.2567 54.315 60.33 54.5166 60.3527 54.7149C60.4745 55.7731 59.0946 56.5629 58.6899 57.8377Z",
    fill: "url(#paint108_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1177 49.0902C59.7515 49.8947 59.0423 50.6215 58.6748 51.398C58.5285 51.2585 58.4349 51.1082 58.4115 50.8932C58.4037 50.843 58.4042 50.7897 58.4044 50.7307C58.41 50.6014 58.4373 50.4543 58.4858 50.2782C58.7468 49.3772 59.6408 48.5778 60.0531 47.6703C60.1997 47.3636 60.2993 47.0731 60.366 46.8008C60.4232 46.9554 60.4668 47.1191 60.4885 47.2949C60.5529 47.8057 60.447 48.4024 60.1177 49.0902Z",
    fill: "url(#paint109_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2941 53.2949L60.3558 54.7121C60.3334 54.5195 60.2598 54.3122 60.1183 54.0911C60.013 53.9301 59.8708 53.7567 59.6832 53.574C59.0719 53.0029 58.5017 52.8622 58.4498 52.3145L58.4473 52.1939L58.4102 50.8906C58.4336 51.1057 58.5301 51.2586 58.6735 51.3955C58.8991 51.613 59.2469 51.8027 59.6215 52.1568C60.0609 52.581 60.2565 52.9485 60.2967 53.292L60.2941 53.2949Z",
    fill: "url(#paint110_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4387 60.5798L61.5007 62.0026C60.9285 60.5908 60.4039 60.7231 59.442 59.9652C58.8075 59.4428 58.532 59.1096 58.5668 58.4907L58.5156 57.3789C58.5399 57.5518 58.5969 57.7009 58.6902 57.8456C58.832 58.0723 59.0602 58.2869 59.3803 58.5479C60.3477 59.3056 60.8667 59.1735 61.439 60.5854L61.4387 60.5798Z",
    fill: "url(#paint111_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1453 20.5807L82.7458 22.1023C80.9386 22.2315 76.2485 23.1121 74.8253 25.1637C74.667 25.3951 74.5457 25.6389 74.4785 25.9L74.8781 24.3784C75.554 21.7925 81.1311 20.7246 83.1424 20.5781L83.1453 20.5807Z",
    fill: "url(#paint112_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0589 51.2234L73.6594 52.745C71.6814 51.4 71.1174 49.9849 71.5021 48.7026C71.5708 48.4751 71.665 48.2549 71.7875 48.0391C71.8273 49.0813 72.5091 50.1741 74.0563 51.2264L74.0589 51.2234Z",
    fill: "url(#paint113_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5292 32.6927L80.5246 32.7154C80.4569 32.9653 80.3146 33.1791 80.1232 33.3587C79.5626 30.2794 74.6602 29.1852 74.4191 26.614C74.3998 26.3651 74.4205 26.1313 74.478 25.9043C74.5452 25.6432 74.6635 25.3967 74.8248 25.168C75.1664 27.7937 80.3857 28.8825 80.5684 32.2392C80.5784 32.4044 80.5652 32.5537 80.5289 32.6871L80.5292 32.6927Z",
    fill: "url(#paint114_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9119 42.5488C77.8278 42.7461 77.6832 42.9039 77.4986 43.0466C77.482 42.9885 77.457 42.9277 77.4319 42.8671C76.8458 41.4586 74.8586 40.4172 74.2725 39.0088C74.054 38.5019 74.0022 38.0889 74.0772 37.7488L74.1013 37.658C74.1748 37.4135 74.3175 37.2107 74.509 37.0312C74.546 37.1727 74.6003 37.3247 74.6663 37.4874C75.2495 38.8931 77.2397 39.9375 77.8258 41.3459C77.9676 41.7017 78.0139 41.9916 77.9854 42.2397C77.9735 42.3525 77.9442 42.4548 77.9036 42.552L77.9119 42.5488Z",
    fill: "url(#paint115_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4186 45.737C73.2198 46.3701 72.2861 47.1601 71.7854 48.035C71.6629 48.2508 71.566 48.4739 71.5 48.6984L71.8234 47.4889L71.9488 47.0176C72.3396 45.9398 73.3914 44.9624 74.8179 44.2099C75.7599 43.7395 76.8698 43.5144 77.4974 43.0409C77.6793 42.901 77.8267 42.7403 77.9107 42.543L77.5956 43.7494C77.4742 44.8912 75.7722 45.0523 74.421 45.7285L74.4186 45.737Z",
    fill: "url(#paint116_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.526 32.7139L80.1503 34.1389L80.1069 34.3036C79.5503 35.9554 75.8375 35.8225 74.5151 37.0306C74.3207 37.2075 74.181 37.4128 74.1074 37.6574L74.4802 36.2296C74.8792 34.4387 78.7881 34.6276 80.1273 33.3542C80.3187 33.1747 80.461 32.9608 80.5286 32.7109L80.526 32.7139Z",
    fill: "url(#paint117_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6941 59.3438L53.164 61.1782C53.164 61.1782 53.1404 63.7917 51.6898 67.9211C51.6823 67.9411 51.6777 67.9639 51.6674 67.9868C51.5352 68.3657 51.5041 68.6813 51.5606 68.9482L51.1172 67.208C51.0319 66.9255 51.0504 66.5767 51.2002 66.1493C52.6687 61.9826 52.6941 59.3438 52.6941 59.3438Z",
    fill: "url(#paint118_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4471 82.1094L59.8942 83.8691L59.928 84.0023C60.0611 84.6728 59.6456 85.3139 59.1125 86.1537L58.6426 84.3193C58.9448 83.8487 59.2102 83.4359 59.3561 83.0479C59.4795 82.7254 59.5253 82.4231 59.4471 82.1094Z",
    fill: "url(#paint119_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4476 82.1074C59.5229 82.4184 59.4801 82.7234 59.3566 83.0459C59.1101 82.7984 58.7845 82.5376 58.3538 82.2505C57.2154 81.4975 55.8746 81.2528 55.5182 79.9634L55.4977 79.8801C55.4293 79.5969 55.4093 79.2666 55.4455 78.875C56.0196 79.5571 57.0139 79.8338 57.8866 80.4131C58.8633 81.0609 59.3214 81.5938 59.4474 82.1018L59.4476 82.1074Z",
    fill: "url(#paint120_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9982 69.9434L57.445 71.6975L57.4857 71.8585C57.6913 72.9074 56.9052 74.4458 56.2283 76.1057C55.749 77.2799 55.5075 78.1772 55.4481 78.8757C55.4148 79.2701 55.4348 79.6003 55.5003 79.8809L55.0299 78.0353C54.8498 77.2518 55.0129 76.0997 55.761 74.2683C56.2348 73.1 56.7674 71.9908 56.9688 71.0728C57.0598 70.6507 57.0851 70.2651 57.0035 69.9375L56.9982 69.9434Z",
    fill: "url(#paint121_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9948 69.9403L57.0007 69.9457C57.0825 70.2789 57.0572 70.6644 56.9632 71.0838C55.6621 70.2678 52.0519 70.6215 51.5846 69.0423L51.5608 68.9451C51.5072 68.6808 51.5354 68.3625 51.6676 67.9835C51.6752 67.9635 51.6827 67.9436 51.69 67.918C53.0559 68.8042 56.2404 68.5336 56.8594 69.6011C56.92 69.7051 56.967 69.8181 56.9975 69.9374L56.9948 69.9403Z",
    fill: "url(#paint122_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.513 55.5273L112.042 57.2976C112.042 57.2976 109.453 59.1418 104.351 60.6661C104.326 60.6756 104.298 60.6825 104.27 60.6893C103.799 60.8277 103.468 61.0245 103.246 61.2727L104.641 59.5928C104.861 59.3053 105.213 59.0739 105.742 58.919C110.898 57.3895 113.513 55.5273 113.513 55.5273Z",
    fill: "url(#paint123_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9204 78.4453L94.5043 80.143L94.3976 80.2712C93.8377 80.882 92.8998 80.9313 91.6934 81.0035L93.1654 79.2332C93.8456 79.1952 94.4389 79.1581 94.9299 79.0273C95.3349 78.9198 95.6669 78.7454 95.9177 78.4483L95.9204 78.4453Z",
    fill: "url(#paint124_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.92 78.4435C95.6692 78.7407 95.3372 78.9151 94.9322 79.0225C95.0011 78.607 95.0237 78.0953 94.9964 77.4679C94.9241 75.8098 94.208 74.3144 95.2218 73.0439L95.2914 72.9679C95.5182 72.697 95.8297 72.4393 96.2398 72.1914C95.9798 73.2438 96.4126 74.4204 96.471 75.6947C96.5302 77.1205 96.3362 77.9483 95.9227 78.4406L95.92 78.4435Z",
    fill: "url(#paint125_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.146 67.3438L104.735 69.0355L104.604 69.19C103.717 70.1406 101.643 70.4667 99.5221 70.9856C98.0228 71.354 96.9686 71.7591 96.2355 72.1951C95.8225 72.4404 95.5139 72.7008 95.2812 72.9663L96.7613 71.1872C97.3998 70.4495 98.6533 69.7859 100.988 69.2156C102.479 68.8504 103.949 68.5787 104.996 68.1234C105.478 67.9144 105.871 67.6615 106.14 67.3439L106.146 67.3438Z",
    fill: "url(#paint126_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.153 67.334L106.145 67.3428C105.881 67.6601 105.485 67.9103 105.003 68.1249C104.877 66.2615 101.952 62.9568 103.168 61.3717L103.251 61.2811C103.468 61.0331 103.801 60.8334 104.272 60.695C104.3 60.6882 104.325 60.6787 104.353 60.6719C104.456 62.6542 107 65.5937 106.389 66.9645C106.33 67.0989 106.249 67.2232 106.156 67.3367L106.153 67.334Z",
    fill: "url(#paint127_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8639 64.6309L22.7481 65.6026C22.913 65.7806 23.1383 65.928 23.4435 66.041C24.4996 66.4496 26.4211 64.887 27.9088 64.7015C28.0902 64.6796 28.2529 64.6781 28.3942 64.7C28.6567 64.7363 28.8492 64.8374 28.9907 64.994L28.1036 64.0196C27.8856 63.7821 27.5382 63.6682 27.0219 63.7327C25.5343 63.9182 23.6157 65.4834 22.5566 65.0722C22.5111 65.0573 22.4653 65.0369 22.4224 65.0191C22.185 64.9144 22.0025 64.7848 21.8613 64.6338L21.8639 64.6309Z",
    fill: "url(#paint128_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1292 83.184L41.0134 84.1557C41.0382 83.6299 40.8633 83.2222 40.5627 82.8929L40.5539 82.8849C40.4036 82.7203 40.2178 82.5768 40.0156 82.4453C40.1009 82.6633 40.1452 82.9083 40.1318 83.1811L40.1292 83.184Z",
    fill: "url(#paint129_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8401 64.602L21.8664 64.6261C22.005 64.7801 22.1874 64.9096 22.4249 65.0143C22.0884 63.7971 23.0279 61.9153 22.5365 60.3624L21.6524 59.3906C22.2312 61.2119 20.8426 63.4781 21.8374 64.605L21.8401 64.602Z",
    fill: "url(#paint130_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7775 79.5927C34.9002 79.7052 35.0456 79.8223 35.2159 79.93C34.7803 78.8208 35.7705 77.5233 35.8393 76.0751C35.8624 75.2519 35.6478 74.6411 35.2783 74.211C35.2488 74.1786 35.2223 74.1489 35.1928 74.1165C35.0518 73.9711 34.8922 73.8518 34.7166 73.75C34.8813 74.116 34.968 74.5612 34.9551 75.1034C34.8734 76.8356 33.4692 78.356 34.7719 79.5929L34.7775 79.5927Z",
    fill: "url(#paint131_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5125 80.4077L35.5184 80.4131C35.6721 80.5916 35.8788 80.765 36.1469 80.9301C37.0155 81.4788 38.8613 81.7183 40.0126 82.4455C40.2175 82.574 40.4007 82.7204 40.5508 82.885L39.6668 81.9133C38.6625 80.8262 36.2846 80.6098 35.2631 79.964C35.2514 79.9533 35.2313 79.9457 35.2197 79.935C35.0465 79.8247 34.9013 79.7131 34.7812 79.5977L35.5128 80.4133L35.5125 80.4077Z",
    fill: "url(#paint132_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3913 72.9461L28.2224 73.8584L28.3196 73.9636C28.3518 73.993 28.381 74.0198 28.4102 74.0466C29.2742 74.747 30.5058 73.9666 31.4152 73.7137C32.573 73.3012 33.842 73.2488 34.7227 73.7548C34.8983 73.8566 35.0578 73.976 35.1989 74.1213L34.3147 73.1496C33.4627 72.2719 31.9153 72.2467 30.531 72.742C29.7575 72.958 28.748 73.5548 27.9313 73.2958C27.7891 73.2514 27.6512 73.1789 27.526 73.0749C27.4793 73.032 27.4354 72.9918 27.3887 72.949L27.3913 72.9461Z",
    fill: "url(#paint133_linear_71858_280549)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3761 72.9281L27.3937 72.9442C27.4322 72.9903 27.4789 73.0331 27.5284 73.0731C27.6562 73.1741 27.7914 73.2496 27.9337 73.2939C27.6808 72.449 27.9462 71.3262 28.157 70.6267C28.6689 68.9768 29.8674 65.9556 28.9891 64.9893C28.8476 64.8327 28.6522 64.7289 28.3926 64.6953C28.5897 66.0001 27.699 68.2922 27.2758 69.6577C27.0084 70.542 26.6532 72.115 27.3791 72.9308L27.3761 72.9281Z",
    fill: "url(#paint134_linear_71858_280549)"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2695 41.0882L13.6668 36.8231L13.5319 35.7755L10.9944 34.9297L10.2695 41.0882Z",
    fill: "#A8AAA2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.44502 29.8484L0.841801 31.3962C0.253951 31.6458 0.296243 32.4831 0.905238 32.6819L8.14551 34.9995L11.753 36.154L21.2389 39.4443C21.6449 39.5797 22.0721 39.3259 22.144 38.9072L24.9436 22.194C25.0325 21.6569 24.4911 21.234 23.9879 21.4539L16.4262 24.7019L4.44502 29.8484Z",
    fill: "#DAE0D1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9211 32.0253L8.14453 35.0026L9.56975 40.9826C9.66279 41.3633 10.1999 41.3759 10.3098 40.9995L11.5744 36.5843C11.6589 36.2925 11.8027 36.0218 11.9973 35.7892L21.627 24.9334C21.8046 24.7304 21.534 24.4471 21.3267 24.612L15.4271 29.2598L11.9211 32.0253Z",
    fill: "#C0C4B8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72559 32.3927C13.4627 32.3927 16.4922 29.3631 16.4922 25.626C16.4922 21.8889 13.4627 18.8594 9.72559 18.8594C5.9885 18.8594 2.95898 21.8889 2.95898 25.626C2.95898 29.3631 5.9885 32.3927 9.72559 32.3927Z",
    fill: "#FFE73B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.7273 30.7008C12.5301 30.7008 14.8023 28.4286 14.8023 25.6258C14.8023 22.8229 12.5301 20.5508 9.7273 20.5508C6.92448 20.5508 4.65234 22.8229 4.65234 25.6258C4.65234 28.4286 6.92448 30.7008 9.7273 30.7008Z",
    fill: "#FCC029"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72639 31.1247C6.69495 31.1247 4.22852 28.6583 4.22852 25.6268C4.22852 22.5953 6.69495 20.1289 9.72639 20.1289C12.7578 20.1289 15.2242 22.5953 15.2242 25.6268C15.2242 28.6583 12.7578 31.1247 9.72639 31.1247ZM9.72639 20.9747C7.16142 20.9747 5.07435 23.0618 5.07435 25.6268C5.07435 28.1918 7.16142 30.2789 9.72639 30.2789C12.2913 30.2789 14.3784 28.1918 14.3784 25.6268C14.3784 23.0618 12.2913 20.9747 9.72639 20.9747Z",
    fill: "#F9B52B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M121.965 20.6753L113.796 35.9677L113.787 35.9832L113.248 36.3791C112.534 36.9033 111.611 36.8436 111.185 36.245L107.242 30.6985C106.816 30.1001 107.05 29.1901 107.764 28.6655L108.09 28.4259L119.533 20.0213C120.246 19.4969 121.17 19.5568 121.595 20.1554L121.965 20.6753Z",
    fill: "#6CF5C2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M114.579 35.5463L114.416 35.8493L114.407 35.8657L113.832 36.2856C113.072 36.8415 112.088 36.7784 111.635 36.1439L107.433 30.2651C106.98 29.6308 107.229 28.6661 107.989 28.1097L108.336 27.8557L109.239 27.1953C108.621 27.7629 108.447 28.6219 108.863 29.2033L113.064 35.0808C113.389 35.5356 113.987 35.6966 114.579 35.5463Z",
    fill: "#05E39C"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M127.499 28.5025L116.106 36.86C115.301 37.4505 114.259 37.3829 113.779 36.709L110.05 31.4708C109.57 30.797 109.833 29.7721 110.638 29.1816L122.032 20.824C122.837 20.2336 123.878 20.3011 124.358 20.975L128.088 26.2132C128.568 26.8871 128.304 27.912 127.499 28.5025Z",
    fill: "#6CF5C2"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M120.213 31.3558C121.844 30.4828 122.697 28.6486 122.119 27.2587C121.54 25.8689 119.749 25.4499 118.118 26.3228C116.487 27.1957 115.634 29.03 116.212 30.4198C116.791 31.8096 118.582 32.2287 120.213 31.3558Z",
    fill: "#05E39C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M117.287 36.2627L116.719 36.6794C115.834 37.328 114.705 37.2808 114.196 36.5747L110.239 31.0838C109.73 30.3777 110.033 29.2796 110.917 28.631L111.176 28.4414C111.086 28.8525 111.148 29.2628 111.383 29.5892L115.803 35.7219C116.123 36.1668 116.69 36.3499 117.287 36.2627Z",
    fill: "#05E39C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M104.957 38.2606C104.794 38.3461 104.606 38.3313 104.507 38.2145C104.39 38.0774 104.44 37.8515 104.618 37.71L106.615 36.12C106.793 35.9788 107.031 35.9751 107.148 36.1123C107.265 36.2494 107.215 36.4753 107.037 36.6167L105.04 38.2067C105.014 38.2277 104.986 38.2457 104.957 38.2606Z",
    fill: "#05E39C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M109.427 40.7998C109.264 40.8853 109.076 40.8704 108.977 40.7537C108.86 40.6165 108.91 40.3907 109.087 40.2492L111.085 38.6592C111.262 38.5179 111.501 38.5142 111.618 38.6514C111.734 38.7886 111.685 39.0144 111.507 39.1559L109.51 40.7459C109.483 40.7669 109.455 40.7849 109.427 40.7998Z",
    fill: "#05E39C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M106.396 40.0024C106.235 40.0863 106.05 40.073 105.95 39.9596C105.832 39.8253 105.878 39.6013 106.054 39.4594L109.134 36.97C109.31 36.828 109.548 36.8219 109.666 36.9563C109.785 37.0907 109.738 37.3146 109.562 37.4565L106.482 39.9459C106.455 39.968 106.426 39.9869 106.396 40.0024Z",
    fill: "#05E39C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M108.375 35.5422C108.207 35.6313 108.015 35.615 107.914 35.4923C107.796 35.3489 107.849 35.1148 108.031 34.9692L108.461 34.6259C108.643 34.4804 108.886 34.4786 109.003 34.6219C109.121 34.7653 109.069 34.9994 108.886 35.145L108.457 35.4883C108.43 35.5092 108.403 35.5272 108.375 35.5422Z",
    fill: "#05E39C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M107.295 42.6582C107.128 42.7463 106.937 42.73 106.837 42.6086C106.721 42.467 106.773 42.2357 106.954 42.0921L107.721 41.4837C107.902 41.3402 108.143 41.3386 108.259 41.4803C108.376 41.6219 108.323 41.8532 108.143 41.9968L107.376 42.6052C107.35 42.6258 107.323 42.6434 107.295 42.6582Z",
    fill: "#05E39C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8477 56.332H93.1554V87.0388H40.8477V56.332Z",
    fill: "#F1B974"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1647 87.0399H40.8477L60.6055 70.9688L61.6615 71.6912L67.247 75.5446L72.8325 71.6912L73.8793 70.9688L93.1647 87.0399Z",
    fill: "#F1B974"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1647 56.332V56.3413L67.247 75.5434L40.8477 56.3413V56.332H93.1647Z",
    fill: "#F1B974"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1714 56.331L93.1622 56.3403L67.2445 75.5424L40.8452 56.3403L40.8359 56.331L67.2445 37.1289L93.1714 56.331Z",
    fill: "#FEC10D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1714 56.331L93.1622 56.3403L67.2445 75.5424L40.8452 56.3403L40.8359 56.331L67.2445 37.1289L93.1714 56.331Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1484 72.6797H76.8599V73.8839H57.1484V72.6797Z",
    fill: "#BDBDBE"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6017 36.9984V84.7026H45.3809V27.7539H79.348L88.6017 36.9984Z",
    fill: "#F1F3F7"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6017 36.9984V84.7026H45.3809V27.7539H79.348L88.6017 36.9984Z",
    fill: "#EFF3F5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6013 36.9984H79.3477V27.7539L88.6013 36.9984Z",
    fill: "#00B3B5"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3438 37L88.6344 46.2908V37H79.3438Z",
    fill: "#00B3B5",
    fillOpacity: 0.08
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9629 49.3086H79.0187V50.5128H54.9629V49.3086Z",
    fill: "#FEC10D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8613 55.5312H84.1248V56.7355H49.8613V55.5312Z",
    fill: "#00B3B5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8613 59.5312H84.1248V60.7355H49.8613V59.5312Z",
    fill: "#00B3B5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8594 63.543H83.9747V64.7472H49.8594V63.543Z",
    fill: "#00B3B5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8594 67.5469H83.9747V68.7511H49.8594V67.5469Z",
    fill: "#00B3B5"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8594 71.5547H69.5709V72.7589H49.8594V71.5547Z",
    fill: "#00B3B5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6719 34.8594H74.9646V36.0636H60.6719V34.8594Z",
    fill: "#00B3B5"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6719 38.8711H74.9646V40.0753H60.6719V38.8711Z",
    fill: "#00B3B5"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6719 42.8711H74.9646V44.0753H60.6719V42.8711Z",
    fill: "#00B3B5"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1624 56.3398V87.0373L73.877 70.9661L93.1624 56.3398Z",
    fill: "#FEC10D"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6055 70.9661L40.8477 87.0373V56.3398L60.6055 70.9661Z",
    fill: "#FEC10D"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1647 87.0385L90.4321 85.1489L72.8325 71.6898L67.247 67.8271L61.6522 71.6898L43.5802 85.1489L40.8477 87.0385L60.6055 70.9673L67.247 65.9375L73.8793 70.9673L93.1647 87.0385Z",
    fill: "#FEC10D"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1647 87.0385L90.4321 85.1489L72.8325 71.6898L67.247 67.8271L61.6522 71.6898L43.5802 85.1489L40.8477 87.0385L60.6055 70.9673L67.247 65.9375L73.8793 70.9673L93.1647 87.0385Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8359 86.7622L67.2445 67.5508L93.1714 86.7622H40.8359Z",
    fill: "#FEC10D"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6104 34.8945H54.7139C54.9391 35.0983 55.1272 35.3344 55.2773 35.6025C55.4274 35.8706 55.5235 36.1764 55.5664 36.5195H57.6104V37.5977H55.5986C55.5235 38.3808 55.223 38.9928 54.6973 39.4326C54.1823 39.8723 53.5066 40.1564 52.6699 40.2852L55.7754 45.3066H53.7646L50.7715 40.0762V39.2236H51.3018C51.8167 39.2236 52.2573 39.1698 52.6221 39.0625C52.9867 38.9552 53.2757 38.7828 53.4902 38.5469C53.7048 38.3001 53.8389 37.9839 53.8926 37.5977H50.7715V36.5195H53.877C53.8019 36.1548 53.6628 35.8542 53.459 35.6182C53.2551 35.3714 52.981 35.1893 52.6377 35.0713C52.2944 34.9533 51.8812 34.8945 51.3984 34.8945H50.7715V33.8164H57.6104V34.8945Z",
    fill: "#DF4666"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6104 34.8945V35.1266H57.8425V34.8945H57.6104ZM54.7139 34.8945V34.6624H54.1115L54.5581 35.0666L54.7139 34.8945ZM55.2773 35.6025L55.4799 35.4892L55.4799 35.4891L55.2773 35.6025ZM55.5664 36.5195L55.3361 36.5483L55.3615 36.7516H55.5664V36.5195ZM57.6104 36.5195H57.8425V36.2874H57.6104V36.5195ZM57.6104 37.5977V37.8298H57.8425V37.5977H57.6104ZM55.5986 37.5977V37.3656H55.3877L55.3676 37.5755L55.5986 37.5977ZM54.6973 39.4326L54.5483 39.2546L54.5465 39.2561L54.6973 39.4326ZM52.6699 40.2852L52.6346 40.0557L52.2881 40.1091L52.4725 40.4072L52.6699 40.2852ZM55.7754 45.3066V45.5387H56.1918L55.9728 45.1846L55.7754 45.3066ZM53.7646 45.3066L53.5632 45.4219L53.63 45.5387H53.7646V45.3066ZM50.7715 40.0762H50.5394V40.1379L50.57 40.1915L50.7715 40.0762ZM50.7715 39.2236V38.9915H50.5394V39.2236H50.7715ZM52.6221 39.0625L52.6876 39.2852L52.6876 39.2852L52.6221 39.0625ZM53.4902 38.5469L53.662 38.703L53.6654 38.6992L53.4902 38.5469ZM53.8926 37.5977L54.1225 37.6296L54.1591 37.3656H53.8926V37.5977ZM50.7715 37.5977H50.5394V37.8298H50.7715V37.5977ZM50.7715 36.5195V36.2874H50.5394V36.5195H50.7715ZM53.877 36.5195V36.7516H54.1617L54.1043 36.4727L53.877 36.5195ZM53.459 35.6182L53.28 35.766L53.2833 35.7699L53.459 35.6182ZM52.6377 35.0713L52.7131 34.8518L52.7131 34.8518L52.6377 35.0713ZM50.7715 34.8945H50.5394V35.1266H50.7715V34.8945ZM50.7715 33.8164V33.5843H50.5394V33.8164H50.7715ZM57.6104 33.8164H57.8425V33.5843H57.6104V33.8164ZM57.6104 34.8945V34.6624H54.7139V34.8945V35.1266H57.6104V34.8945ZM54.7139 34.8945L54.5581 35.0666C54.7645 35.2534 54.9369 35.4697 55.0748 35.7159L55.2773 35.6025L55.4799 35.4891C55.3175 35.1992 55.1136 34.9432 54.8696 34.7224L54.7139 34.8945ZM55.2773 35.6025L55.0748 35.7159C55.2084 35.9546 55.2964 36.231 55.3361 36.5483L55.5664 36.5195L55.7967 36.4907C55.7506 36.1218 55.6464 35.7867 55.4799 35.4892L55.2773 35.6025ZM55.5664 36.5195V36.7516H57.6104V36.5195V36.2874H55.5664V36.5195ZM57.6104 36.5195H57.3782V37.5977H57.6104H57.8425V36.5195H57.6104ZM57.6104 37.5977V37.3656H55.5986V37.5977V37.8298H57.6104V37.5977ZM55.5986 37.5977L55.3676 37.5755C55.2974 38.3077 55.0202 38.8597 54.5483 39.2546L54.6973 39.4326L54.8462 39.6106C55.4257 39.1258 55.7497 38.454 55.8297 37.6198L55.5986 37.5977ZM54.6973 39.4326L54.5465 39.2561C54.0717 39.6616 53.4392 39.932 52.6346 40.0557L52.6699 40.2852L52.7052 40.5146C53.5739 40.3809 54.2929 40.0831 54.848 39.6091L54.6973 39.4326ZM52.6699 40.2852L52.4725 40.4072L55.578 45.4287L55.7754 45.3066L55.9728 45.1846L52.8673 40.1631L52.6699 40.2852ZM55.7754 45.3066V45.0745H53.7646V45.3066V45.5387H55.7754V45.3066ZM53.7646 45.3066L53.9661 45.1914L50.9729 39.9609L50.7715 40.0762L50.57 40.1915L53.5632 45.4219L53.7646 45.3066ZM50.7715 40.0762H51.0036V39.2236H50.7715H50.5394V40.0762H50.7715ZM50.7715 39.2236V39.4557H51.3018V39.2236V38.9915H50.7715V39.2236ZM51.3018 39.2236V39.4557C51.8317 39.4557 52.2956 39.4005 52.6876 39.2852L52.6221 39.0625L52.5566 38.8398C52.2191 38.9391 51.8018 38.9915 51.3018 38.9915V39.2236ZM52.6221 39.0625L52.6876 39.2852C53.0856 39.168 53.414 38.9758 53.662 38.703L53.4902 38.5469L53.3185 38.3907C53.1374 38.5899 52.8878 38.7424 52.5566 38.8398L52.6221 39.0625ZM53.4902 38.5469L53.6654 38.6992C53.9147 38.4124 54.0638 38.0517 54.1225 37.6296L53.8926 37.5977L53.6627 37.5657C53.614 37.916 53.4949 38.1878 53.3151 38.3946L53.4902 38.5469ZM53.8926 37.5977V37.3656H50.7715V37.5977V37.8298H53.8926V37.5977ZM50.7715 37.5977H51.0036V36.5195H50.7715H50.5394V37.5977H50.7715ZM50.7715 36.5195V36.7516H53.877V36.5195V36.2874H50.7715V36.5195ZM53.877 36.5195L54.1043 36.4727C54.0228 36.077 53.8691 35.7379 53.6347 35.4665L53.459 35.6182L53.2833 35.7699C53.4565 35.9704 53.5809 36.2327 53.6496 36.5663L53.877 36.5195ZM53.459 35.6182L53.6379 35.4703C53.4032 35.1862 53.0911 34.9817 52.7131 34.8518L52.6377 35.0713L52.5622 35.2908C52.8709 35.3969 53.1071 35.5566 53.28 35.766L53.459 35.6182ZM52.6377 35.0713L52.7131 34.8518C52.339 34.7232 51.8988 34.6624 51.3984 34.6624V34.8945V35.1266C51.8636 35.1266 52.2498 35.1834 52.5622 35.2908L52.6377 35.0713ZM51.3984 34.8945V34.6624H50.7715V34.8945V35.1266H51.3984V34.8945ZM50.7715 34.8945H51.0036V33.8164H50.7715H50.5394V34.8945H50.7715ZM50.7715 33.8164V34.0485H57.6104V33.8164V33.5843H50.7715V33.8164ZM57.6104 33.8164H57.3782V34.8945H57.6104H57.8425V33.8164H57.6104Z",
    fill: "#DF4666"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1523 28.9062L8.6129 26.2165V25.7778H8.88602C9.15086 25.7778 9.37707 25.7503 9.56467 25.6951C9.75226 25.6399 9.90123 25.5516 10.0116 25.4302C10.1219 25.3033 10.1909 25.1406 10.2185 24.9419H8.6129V24.3874H10.2102C10.1716 24.1998 10.0999 24.0454 9.99503 23.924C9.8902 23.7971 9.7495 23.7033 9.57294 23.6426C9.39638 23.5819 9.18396 23.5515 8.93568 23.5515H8.6129V22.997H12.1303V23.5515H10.6406C10.7564 23.6564 10.853 23.7778 10.9302 23.9157C11.0075 24.0536 11.0571 24.2109 11.0792 24.3874H12.1303V24.9419H11.0958C11.0571 25.3447 10.9027 25.6592 10.6323 25.8854C10.3675 26.1117 10.0199 26.2579 9.5895 26.3241L11.1868 28.9062H10.1523Z",
    fill: "#FFE73B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_71858_280549",
    x1: 75.3629,
    y1: 91.2878,
    x2: 75.5167,
    y2: 92.5001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFD946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD22B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFC90A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_71858_280549",
    x1: 110.217,
    y1: 49.9044,
    x2: 111.787,
    y2: 50.2366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ED170B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C10300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#970300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_71858_280549",
    x1: 71.4907,
    y1: 67.0843,
    x2: 71.893,
    y2: 67.7016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFD946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD22B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFC90A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_71858_280549",
    x1: 109.967,
    y1: 72.3507,
    x2: 109.959,
    y2: 71.1494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFD946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD22B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFC90A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_71858_280549",
    x1: 78.3196,
    y1: 39.794,
    x2: 78.2139,
    y2: 39.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#00B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_71858_280549",
    x1: 70.8145,
    y1: 60.4754,
    x2: 71.3046,
    y2: 61.5525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00880B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#39B512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#59BC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#70C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5DBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#40B612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1BAE12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_71858_280549",
    x1: 54.4111,
    y1: 21.3195,
    x2: 53.0206,
    y2: 22.9897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFD946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD22B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFC90A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_71858_280549",
    x1: 66.1287,
    y1: 30.5867,
    x2: 66.9014,
    y2: 31.4261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFD946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD22B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFC90A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_71858_280549",
    x1: 82.3528,
    y1: 103.86,
    x2: 80.5587,
    y2: 104.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFD946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD22B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFC90A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_71858_280549",
    x1: 14.1606,
    y1: 45.6118,
    x2: 14.5409,
    y2: 44.5195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AD0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D00069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FF1A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF3F91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF5E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF3E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FF198B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AE0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_71858_280549",
    x1: 53.9617,
    y1: 72.5081,
    x2: 55.6174,
    y2: 71.2226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFD946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD22B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFC90A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_71858_280549",
    x1: 21.1178,
    y1: 93.7467,
    x2: 22.0771,
    y2: 92.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AD0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D00069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FF1A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF3F91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF5E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF3E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FF198B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AE0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_71858_280549",
    x1: 66.856,
    y1: 70.0846,
    x2: 66.8151,
    y2: 70.883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00880B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#39B512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#59BC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#70C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5DBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#40B612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1BAE12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_71858_280549",
    x1: 71.1199,
    y1: 38.9078,
    x2: 74.0903,
    y2: 40.1031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ED170B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C10300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#970300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_71858_280549",
    x1: 82.811,
    y1: 74.1474,
    x2: 82.926,
    y2: 74.6527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFD946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD22B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFC90A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_71858_280549",
    x1: 55.9156,
    y1: 84.0037,
    x2: 54.5495,
    y2: 83.3797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AD0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D00069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FF1A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF3F91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF5E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF3E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FF198B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AE0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_71858_280549",
    x1: 69.8501,
    y1: 68.4775,
    x2: 68.7816,
    y2: 70.0945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ED170B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C10300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#970300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_71858_280549",
    x1: 45.2322,
    y1: 22.2815,
    x2: 44.1637,
    y2: 23.8984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ED170B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C10300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#970300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_71858_280549",
    x1: 97.6597,
    y1: 42.6802,
    x2: 99.8679,
    y2: 42.3576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFD946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD22B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFC90A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_71858_280549",
    x1: 68.5459,
    y1: 102.671,
    x2: 67.5906,
    y2: 102.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFD946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD22B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFC90A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_71858_280549",
    x1: 35.2634,
    y1: 80.3645,
    x2: 33.987,
    y2: 81.399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00880B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#39B512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#59BC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#70C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5DBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#40B612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1BAE12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_71858_280549",
    x1: 77.7912,
    y1: 103.765,
    x2: 77.1388,
    y2: 102.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ED170B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C10300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#970300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_71858_280549",
    x1: 79.2364,
    y1: 71.0402,
    x2: 80.7348,
    y2: 70.9393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#00B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_71858_280549",
    x1: 98.7365,
    y1: 13.3252,
    x2: 99.6692,
    y2: 12.8729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AD0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D00069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FF1A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF3F91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF5E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF3E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FF198B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AE0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_71858_280549",
    x1: 77.8206,
    y1: 40.5441,
    x2: 77.6024,
    y2: 39.0087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ED170B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C10300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#970300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_71858_280549",
    x1: 43.8217,
    y1: 89.2559,
    x2: 44.8836,
    y2: 89.3533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00880B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#39B512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#59BC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#70C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5DBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#40B612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1BAE12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_71858_280549",
    x1: 67.5062,
    y1: 81.9787,
    x2: 66.0466,
    y2: 82.0311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ED170B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C10300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#970300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_71858_280549",
    x1: 80.5865,
    y1: 83.435,
    x2: 80.4645,
    y2: 84.0524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AD0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D00069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FF1A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF3F91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF5E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF3E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FF198B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AE0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_71858_280549",
    x1: 68.5781,
    y1: 66.9119,
    x2: 68.0325,
    y2: 67.3405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ED170B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C10300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#970300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_71858_280549",
    x1: 28.1686,
    y1: 52.3401,
    x2: 26.9507,
    y2: 53.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ED170B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C10300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#970300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_71858_280549",
    x1: 85.7502,
    y1: 78.4745,
    x2: 85.5318,
    y2: 79.5231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#00B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_71858_280549",
    x1: 55.9928,
    y1: 41.2683,
    x2: 56.8579,
    y2: 40.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00880B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#39B512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#59BC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#70C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5DBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#40B612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1BAE12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_71858_280549",
    x1: 80.551,
    y1: 74.4982,
    x2: 80.0035,
    y2: 74.8603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00880B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#39B512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#59BC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#70C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5DBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#40B612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1BAE12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_71858_280549",
    x1: 81.499,
    y1: 87.2926,
    x2: 82.0516,
    y2: 87.7493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AD0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D00069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FF1A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF3F91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF5E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF3E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FF198B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AE0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_71858_280549",
    x1: 63.3616,
    y1: 42.0144,
    x2: 64.1209,
    y2: 41.1385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ED170B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C10300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#970300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_71858_280549",
    x1: 29.8014,
    y1: 65.5983,
    x2: 29.2909,
    y2: 66.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#00B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_71858_280549",
    x1: 25.3458,
    y1: 63.6975,
    x2: 27.2779,
    y2: 65.3508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00880B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#39B512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#59BC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#70C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5DBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#40B612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1BAE12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_71858_280549",
    x1: 49.3511,
    y1: 95.014,
    x2: 49.793,
    y2: 94.7434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFD946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD22B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFC90A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_71858_280549",
    x1: 37.279,
    y1: 70.9723,
    x2: 37.7931,
    y2: 70.1933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AD0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D00069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FF1A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF3F91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF5E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF3E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FF198B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AE0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_71858_280549",
    x1: 55.2623,
    y1: 91.0123,
    x2: 55.9385,
    y2: 91.2451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00880B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#39B512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#59BC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#70C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5DBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#40B612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1BAE12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_71858_280549",
    x1: 37.1488,
    y1: 71.6607,
    x2: 38.3807,
    y2: 70.6471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#00B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_71858_280549",
    x1: 40.7076,
    y1: 78.6461,
    x2: 41.7885,
    y2: 78.3181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFD946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD22B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFC90A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_71858_280549",
    x1: 77.2311,
    y1: 68.5881,
    x2: 76.9528,
    y2: 66.4413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00880B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#39B512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#59BC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#70C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5DBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#40B612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1BAE12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_71858_280549",
    x1: 59.9387,
    y1: 77.3901,
    x2: 59.0924,
    y2: 77.4137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ED170B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C10300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#970300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_71858_280549",
    x1: 57.8543,
    y1: 93.1548,
    x2: 58.2757,
    y2: 92.6775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFD946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD22B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFC90A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_71858_280549",
    x1: 60.722,
    y1: 55.0799,
    x2: 62.3731,
    y2: 55.9686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00880B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#39B512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#59BC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#70C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5DBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#40B612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1BAE12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_71858_280549",
    x1: 55.3305,
    y1: 60.33,
    x2: 57.2982,
    y2: 61.2414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AD0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D00069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FF1A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF3F91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF5E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF3E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FF198B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AE0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_71858_280549",
    x1: 113.097,
    y1: 87.0218,
    x2: 112.704,
    y2: 89.0759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#00B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_71858_280549",
    x1: 28.1084,
    y1: 80.3124,
    x2: 29.437,
    y2: 79.2973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#00B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_71858_280549",
    x1: 49.4584,
    y1: 84.7332,
    x2: 49.0197,
    y2: 83.1964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#00B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_71858_280549",
    x1: 35.5223,
    y1: 35.2801,
    x2: 36.744,
    y2: 35.5924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AD0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D00069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FF1A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF3F91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF5E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF3E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FF198B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AE0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_71858_280549",
    x1: 100.992,
    y1: 77.1701,
    x2: 99.3787,
    y2: 77.7273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#00B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_71858_280549",
    x1: 87.8456,
    y1: 78.8004,
    x2: 89.1355,
    y2: 76.5113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ED170B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C10300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#970300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_71858_280549",
    x1: 81.5755,
    y1: 70.1894,
    x2: 82.3577,
    y2: 70.9431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ED170B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C10300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#970300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_71858_280549",
    x1: 56.301,
    y1: 63.9862,
    x2: 55.3858,
    y2: 63.9871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00880B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#39B512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#59BC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#70C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5DBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#40B612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1BAE12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_71858_280549",
    x1: 103.698,
    y1: 74.9736,
    x2: 103.587,
    y2: 73.7956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AD0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D00069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FF1A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF3F91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF5E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF3E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FF198B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AE0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_71858_280549",
    x1: 86.9361,
    y1: 49.9488,
    x2: 87.0138,
    y2: 48.5975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#400300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#750300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#A50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#C80300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EE180C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F72E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FF4022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FD3B1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F72D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ED170B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E50300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#DB0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#C10300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#970300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#5E0300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_71858_280549",
    x1: 54.0136,
    y1: 50.9892,
    x2: 55.6999,
    y2: 50.1717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFD946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD22B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFC90A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_71858_280549",
    x1: 36.9143,
    y1: 49.0083,
    x2: 38.3487,
    y2: 48.6857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#00B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_71858_280549",
    x1: 67.6096,
    y1: 106.159,
    x2: 69.2201,
    y2: 105.904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#00B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_71858_280549",
    x1: 57.5814,
    y1: 78.5359,
    x2: 56.9528,
    y2: 79.0665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFD946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD22B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFC90A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_71858_280549",
    x1: 92.5911,
    y1: 84.4238,
    x2: 92.9207,
    y2: 86.2604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AD0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D00069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FF1A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF3F91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF5E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF3E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FF198B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AE0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_71858_280549",
    x1: 48.3961,
    y1: 98.5166,
    x2: 47.928,
    y2: 98.3499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFCD17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFD432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFD946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FFDC52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFDE56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFDC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFD842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FFD22B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFC90A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_71858_280549",
    x1: 93.1779,
    y1: 69.743,
    x2: 94.5579,
    y2: 70.2253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00880B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#39B512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#59BC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#70C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5DBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#40B612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1BAE12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_71858_280549",
    x1: 15.1053,
    y1: 73.5085,
    x2: 13.737,
    y2: 73.5628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00880B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#39B512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#59BC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#70C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5DBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#40B612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1BAE12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_71858_280549",
    x1: 45.5351,
    y1: 68.6977,
    x2: 46.1059,
    y2: 69.3533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#920040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#AD0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#D00069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FF1A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF3F91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF5E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF5595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF3E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FF198B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF0087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#F90083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#EA0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D10069"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#AE0052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920040"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_71858_280549",
    x1: 53.9262,
    y1: 100.316,
    x2: 54.7652,
    y2: 101.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00880B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#39B512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#59BC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#70C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5DBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#40B612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1BAE12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_71858_280549",
    x1: 94.3633,
    y1: 91.3108,
    x2: 93.332,
    y2: 90.9752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00880B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#11AC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#39B512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#59BC12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#70C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#7EC312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#83C512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7EC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#72C112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5DBD12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#40B612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#1BAE12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_71858_280549",
    x1: 66.3521,
    y1: 56.0047,
    x2: 67.245,
    y2: 56.3884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#00D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#00B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_71858_280549",
    x1: 84.7849,
    y1: 71.6163,
    x2: 87.641,
    y2: 72.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_71858_280549",
    x1: 77.8812,
    y1: 86.3936,
    x2: 88.9337,
    y2: 91.8263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_71858_280549",
    x1: 83.4427,
    y1: 74.8827,
    x2: 92.7886,
    y2: 79.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_71858_280549",
    x1: 77.5643,
    y1: 95.5151,
    x2: 81.629,
    y2: 96.8993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_71858_280549",
    x1: 81.6045,
    y1: 81.6877,
    x2: 86.9002,
    y2: 83.4911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_71858_280549",
    x1: 67.6686,
    y1: 96.0593,
    x2: 72.0854,
    y2: 96.2465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#005104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00770A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00920E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00A311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_71858_280549",
    x1: 66.4709,
    y1: 90.9092,
    x2: 77.0488,
    y2: 92.8257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#005104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00770A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00920E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00A311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_71858_280549",
    x1: 67.7979,
    y1: 88.0774,
    x2: 75.3339,
    y2: 89.107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#005104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00770A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00920E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00A311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_71858_280549",
    x1: 67.6596,
    y1: 89.0914,
    x2: 75.1955,
    y2: 90.1211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#005104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00770A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00920E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00A311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_71858_280549",
    x1: 69.2938,
    y1: 85.8351,
    x2: 73.9915,
    y2: 86.6968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#005104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00770A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00920E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00A311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_71858_280549",
    x1: 66.2799,
    y1: 91.9544,
    x2: 76.8578,
    y2: 93.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#005104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00770A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00920E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00A311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_71858_280549",
    x1: 68.3177,
    y1: 87.965,
    x2: 72.5166,
    y2: 88.1429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#005104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00770A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00920E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00A311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_71858_280549",
    x1: 67.7771,
    y1: 91.2779,
    x2: 72.1186,
    y2: 91.4619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#005104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00770A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00920E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00A311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_71858_280549",
    x1: 37.4748,
    y1: 59.4775,
    x2: 41.5264,
    y2: 57.7088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_71858_280549",
    x1: 34.1386,
    y1: 55.3725,
    x2: 44.4855,
    y2: 52.4563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_71858_280549",
    x1: 34.0933,
    y1: 52.2415,
    x2: 41.3139,
    y2: 49.8637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_71858_280549",
    x1: 34.414,
    y1: 53.2114,
    x2: 41.6346,
    y2: 50.8336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_71858_280549",
    x1: 34.4501,
    y1: 49.5694,
    x2: 39.0536,
    y2: 48.2822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_71858_280549",
    x1: 34.4308,
    y1: 56.3948,
    x2: 44.7725,
    y2: 53.4765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_71858_280549",
    x1: 34.5116,
    y1: 51.9111,
    x2: 38.3596,
    y2: 50.2313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_71858_280549",
    x1: 35.4784,
    y1: 55.1308,
    x2: 39.4609,
    y2: 53.3922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_71858_280549",
    x1: 93.8777,
    y1: 49.5127,
    x2: 97.8739,
    y2: 51.4031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_71858_280549",
    x1: 94.7758,
    y1: 44.3031,
    x2: 103.771,
    y2: 50.1813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_71858_280549",
    x1: 97.0982,
    y1: 42.2149,
    x2: 103.64,
    y2: 46.0946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_71858_280549",
    x1: 96.5782,
    y1: 43.0878,
    x2: 103.12,
    y2: 46.9676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_71858_280549",
    x1: 99.3509,
    y1: 40.7246,
    x2: 103.344,
    y2: 43.3458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_71858_280549",
    x1: 94.1924,
    y1: 45.1948,
    x2: 103.192,
    y2: 51.0747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_71858_280549",
    x1: 97.624,
    y1: 42.3069,
    x2: 101.423,
    y2: 44.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_71858_280549",
    x1: 95.8358,
    y1: 45.1498,
    x2: 99.7639,
    y2: 47.0079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_71858_280549",
    x1: 55.2393,
    y1: 100.905,
    x2: 58.7447,
    y2: 98.7259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_71858_280549",
    x1: 51.7881,
    y1: 98.6827,
    x2: 61.4917,
    y2: 95.3075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_71858_280549",
    x1: 52.2751,
    y1: 95.6045,
    x2: 55.2417,
    y2: 93.7605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_71858_280549",
    x1: 48.7059,
    y1: 92.394,
    x2: 57.4924,
    y2: 88.5198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_71858_280549",
    x1: 47.7562,
    y1: 87.5847,
    x2: 50.6892,
    y2: 85.7616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_71858_280549",
    x1: 83.2098,
    y1: 39.5393,
    x2: 95.2741,
    y2: 50.0206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_71858_280549",
    x1: 80.5522,
    y1: 50.4069,
    x2: 85.3856,
    y2: 52.7431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_71858_280549",
    x1: 66.8645,
    y1: 69.7072,
    x2: 79.6546,
    y2: 74.9422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_71858_280549",
    x1: 71.5397,
    y1: 57.803,
    x2: 88.7502,
    y2: 74.9022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_71858_280549",
    x1: 56.5991,
    y1: 45.2088,
    x2: 60.3899,
    y2: 45.0437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_71858_280549",
    x1: 56.8977,
    y1: 56.5586,
    x2: 63.3787,
    y2: 55.0183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_71858_280549",
    x1: 55.8628,
    y1: 50.7115,
    x2: 64.3275,
    y2: 46.9695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_71858_280549",
    x1: 58.4703,
    y1: 52.8392,
    x2: 60.2726,
    y2: 52.7607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_71858_280549",
    x1: 58.2044,
    y1: 59.5915,
    x2: 62.7466,
    y2: 59.8223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_71858_280549",
    x1: 74.5769,
    y1: 24.824,
    x2: 81.3697,
    y2: 26.6017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#005104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00770A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00920E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00A311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_71858_280549",
    x1: 69.6469,
    y1: 51.6473,
    x2: 76.8213,
    y2: 54.8999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#005104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00770A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00920E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00A311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_71858_280549",
    x1: 73.5763,
    y1: 29.8613,
    x2: 84.8566,
    y2: 35.7188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#005104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00770A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00920E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00A311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_71858_280549",
    x1: 72.1798,
    y1: 40.5039,
    x2: 83.4107,
    y2: 46.7588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#005104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00770A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00920E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00A311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_71858_280549",
    x1: 71.6296,
    y1: 47.4725,
    x2: 76.1264,
    y2: 48.6493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#005104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00770A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00920E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00A311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_71858_280549",
    x1: 74.0808,
    y1: 37.0144,
    x2: 78.8744,
    y2: 38.2689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#005104"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#00770A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00920E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#00A311"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#00A912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#009D10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#007F0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#004F04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_71858_280549",
    x1: 50.456,
    y1: 64.5891,
    x2: 53.8215,
    y2: 63.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_71858_280549",
    x1: 58.6482,
    y1: 84.3143,
    x2: 59.9314,
    y2: 83.9871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_71858_280549",
    x1: 54.0244,
    y1: 81.6616,
    x2: 64.8527,
    y2: 79.4858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_71858_280549",
    x1: 54.3671,
    y1: 75.4142,
    x2: 58.1513,
    y2: 74.4493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_71858_280549",
    x1: 51.5839,
    y1: 70.2493,
    x2: 62.9553,
    y2: 67.2353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E61014"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F82831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FD3F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB5C63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F96D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F97478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF313D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#F92C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DD141A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#CC0509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C70003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_71858_280549",
    x1: 106.845,
    y1: 57.0993,
    x2: 110.095,
    y2: 59.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_71858_280549",
    x1: 93.2753,
    y1: 79.262,
    x2: 94.5163,
    y2: 80.2935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_71858_280549",
    x1: 92.5823,
    y1: 72.8119,
    x2: 102.464,
    y2: 81.9186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_71858_280549",
    x1: 98.98,
    y1: 68.6871,
    x2: 102.635,
    y2: 71.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_71858_280549",
    x1: 102.077,
    y1: 62.2546,
    x2: 113.175,
    y2: 71.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0038AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0061C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0097EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00A1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0085E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0059C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0038AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_71858_280549",
    x1: 23.5715,
    y1: 66.4998,
    x2: 27.2968,
    y2: 63.1179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_71858_280549",
    x1: 38.5499,
    y1: 86.8038,
    x2: 42.5543,
    y2: 79.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_71858_280549",
    x1: 20.0011,
    y1: 64.7537,
    x2: 27.6004,
    y2: 55.2577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_71858_280549",
    x1: 33.1833,
    y1: 80.7405,
    x2: 38.4744,
    y2: 69.2327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_71858_280549",
    x1: 36.9012,
    y1: 81.9357,
    x2: 38.4336,
    y2: 80.5446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_71858_280549",
    x1: 29.4538,
    y1: 75.21,
    x2: 33.1468,
    y2: 71.8574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_71858_280549",
    x1: 26.1014,
    y1: 73.8309,
    x2: 32.4917,
    y2: 58.8621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB3C00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_71858_280549"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProvisionalSuccessMobile);
export default __webpack_public_path__ + "static/media/provisional-success-mobile.e55a3ca70d87508c9d0bd26a1f230d71.svg";
export { ForwardRef as ReactComponent };